import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { ProposalProjectCostIT } from "../Model/ProposalProjectCostIT";

export async function createProposalProjectCostIT(data) {
	let response = await getAPIResponse("/v1/proposal-project-cost-it/add", data, "POST");
	if (response === null) {
		return null;
	}
	let proposalProjectCostIT = [];
	response.forEach((element) => {
		proposalProjectCostIT.push(ProposalProjectCostIT.createFromResponseData(element));
	});
	return proposalProjectCostIT;
}
